import * as React from "react";

const ChevDown = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g>
        <path
          d="M11.9998 14.9748C11.8665 14.9748 11.7415 14.954 11.6248 14.9123C11.5081 14.8706 11.3998 14.7998 11.2998 14.6998L6.6998 10.0998C6.51647 9.91647 6.4248 9.68314 6.4248 9.3998C6.4248 9.11647 6.51647 8.88314 6.6998 8.6998C6.88314 8.51647 7.11647 8.4248 7.3998 8.4248C7.68314 8.4248 7.91647 8.51647 8.0998 8.6998L11.9998 12.5998L15.8998 8.6998C16.0831 8.51647 16.3165 8.4248 16.5998 8.4248C16.8831 8.4248 17.1165 8.51647 17.2998 8.6998C17.4831 8.88314 17.5748 9.11647 17.5748 9.3998C17.5748 9.68314 17.4831 9.91647 17.2998 10.0998L12.6998 14.6998C12.5998 14.7998 12.4915 14.8706 12.3748 14.9123C12.2581 14.954 12.1331 14.9748 11.9998 14.9748Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
export default ChevDown;
